import { updateMiniBasket } from './updateMiniBasket';
import { updateMiniBasketBtn } from './updateMiniBasketBtn';
import { updateAddToBasketPopup } from './updateAddToBasketPopup';
import { displayError } from './displayError';
import { updateButton } from './updateButton';
import { NotificationService, NotificationType } from '../utils/NotificationService';
import { GTM_productFromPage } from '../tracking_scripts/tag_manager/events';

/**
 * Handles the server response after adding the product to the basket.
 * @param {any} response - The response object from the server.
 * @param {number} productId - The ID of the product being added.
 * @param {string} productType - The type of product being added.
 * @param {number} quantity - The amount of product added
 * @param {HTMLButtonElement} button - The 'Add to basket' button event listener.
 * @param {string} depositPrice - The deposit price if present.
 */
export function handleResponse(
	response: any,
	productId: number,
	productType: string,
	quantity: number,
	button: HTMLButtonElement,
	depositPrice: string | null,
): void {
	if (response.status === 'success') {
		const masthead = document.getElementById('masthead');
		if (masthead) {
			updateAddToBasketPopup(response);
			updateMiniBasketBtn(response);
			updateMiniBasket(response);
		} else {
			// Webviews in the app don't have a masthead/minibasket
			NotificationService.showNotification(
				NotificationType.success,
				'Added to basket',
				response.addedQty + ' x ' + response.productName,
			);
		}

		updateButton(button, false, true, depositPrice as string);

		// TagManager Event
		const subtotal = parseFloat(response.subtotal.replace(/[^\d.-]/g, ''));
		const total = parseFloat(response.total.replace(/[^\d.-]/g, ''));

		GTM_productFromPage(
			productId,
			Number(quantity),
			response.productName,
			response.basketItems,
			subtotal,
			total,
		);
	} else {
		displayError(response.errorMsg);
		updateButton(button, false, false, depositPrice as string);
	}
}
